(() => {
  const init = () => {
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const reveal = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('kv-in-view');
        reveal.unobserve(entry.target);
      });
    }, {threshold: .12});
    document.querySelectorAll('.kv-story [data-kv-reveal]').forEach(element => {
      if (element.dataset.motionReady) return;
      element.dataset.motionReady = 'true';
      reveal.observe(element);
    });
    document.querySelectorAll('.kv-evolution .timeline-container').forEach(timeline => {
      if (timeline.dataset.motionReady) return;
      timeline.dataset.motionReady = 'true';
      const cards = [...timeline.querySelectorAll('.generation-card')];
      const rail = timeline.querySelector('.kv-evolution-rail');
      let queued = false;
      const update = () => {
        queued = false;
        const vertical = matchMedia('(max-width: 900px)').matches;
        const box = rail.getBoundingClientRect();
        const section = timeline.closest('.kv-evolution').getBoundingClientRect();
        const raw = vertical ? (innerHeight * .72 - box.top) / box.height : (innerHeight * .82 - section.top) / (innerHeight * .58);
        const progress = reducedMotion.matches ? 1 : Math.max(0, Math.min(1, raw));
        timeline.style.setProperty('--kv-progress', progress.toFixed(4));
        cards.forEach((card, index) => {
          const reached = reducedMotion.matches || (vertical ? card.querySelector('.kv-stage-marker').getBoundingClientRect().top < innerHeight * .72 : progress >= index / (cards.length - 1));
          card.classList.toggle('kv-stage-active', reached);
        });
      };
      const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
      const resize = () => {
        timeline.style.setProperty('--kv-last-stage-height', cards[cards.length - 1].offsetHeight + 'px');
        schedule();
      };
      addEventListener('scroll', schedule, {passive:true});
      addEventListener('resize', resize, {passive:true});
      reducedMotion.addEventListener('change', schedule);
      new ResizeObserver(resize).observe(timeline);
      resize();
    });
    document.querySelectorAll('.kv-story .hotspot-container').forEach(container => {
      if (container.dataset.ready) return;
      container.dataset.ready = 'true';
      const buttons = [...container.querySelectorAll('[data-kv-hotspot]')];
      let active;
      const position = () => {
        if (!active) return;
        const tip = container.querySelector('[data-kv-tooltip="' + active.dataset.kvHotspot + '"]');
        const x = active.offsetLeft, y = active.offsetTop;
        const bw = active.offsetWidth, bh = active.offsetHeight;
        const width = tip.offsetWidth, height = tip.offsetHeight;
        const gap = 15, edge = 12;
        let left, top, side, arrow;
        if (container.clientWidth - x - bw >= width + gap + edge) {
          side = 'right'; left = x + bw + gap;
          top = Math.max(edge, Math.min(y + bh / 2 - height / 2, container.clientHeight - height - edge));
          arrow = y + bh / 2 - top;
        } else if (x >= width + gap + edge) {
          side = 'left'; left = x - width - gap;
          top = Math.max(edge, Math.min(y + bh / 2 - height / 2, container.clientHeight - height - edge));
          arrow = y + bh / 2 - top;
        } else {
          side = 'above'; left = Math.max(edge, Math.min(x + bw / 2 - width / 2, container.clientWidth - width - edge));
          top = y - height - gap; arrow = x + bw / 2 - left;
          if (top < edge) { side = 'below'; top = y + bh + gap; }
        }
        tip.style.left = left + 'px'; tip.style.top = top + 'px';
        tip.style.setProperty('--arrow-position', arrow + 'px'); tip.dataset.side = side;
      };
      const close = () => {
        buttons.forEach(b => b.setAttribute('aria-expanded', 'false'));
        container.querySelectorAll('[data-kv-tooltip]').forEach(t => t.hidden = true);
        active = null;
      };
      const open = button => {
        close(); active = button;
        button.setAttribute('aria-expanded', 'true');
        container.querySelector('[data-kv-tooltip="' + button.dataset.kvHotspot + '"]').hidden = false;
        position();
      };
      buttons.forEach(button => button.addEventListener('click', () => active === button ? close() : open(button)));
      container.addEventListener('keydown', event => {
        if (event.key === 'Escape' && active) { const button = active; close(); button.focus({preventScroll:true}); }
      });
      document.addEventListener('click', event => { if (!container.contains(event.target)) close(); });
      new ResizeObserver(position).observe(container);
      if (buttons[0]) open(buttons[0]);
    });
    document.querySelectorAll('[data-kv-addons]').forEach(carousel => {
      if (carousel.dataset.ready) return;
      carousel.dataset.ready = 'true';
      const track = carousel.querySelector('[data-kv-addon-track]');
      const prev = carousel.querySelector('[data-kv-addon-prev]');
      const next = carousel.querySelector('[data-kv-addon-next]');
      const sync = () => {
        prev.disabled = track.scrollLeft < 4;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      };
      const move = direction => {
        const card = track.firstElementChild;
        if (!card) return;
        track.scrollBy({left: direction * (card.offsetWidth + parseFloat(getComputedStyle(track).gap)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      prev.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', sync, {passive:true});
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
      });
      new ResizeObserver(sync).observe(track); sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
